/**
 * Why the lift calendar is empty — which is two different questions (#2500).
 *
 * The calendar used to answer both with "no bookings" while testing
 * `lifts.length === 0`, so a workshop with no lifts configured read it as
 * having no customers. It cannot show a single booking until a lift exists to
 * hang one on, which is a setup gap rather than a quiet day.
 *
 * Pulled out of the component because the distinction is the whole fix and
 * the component itself is impractical to render in a test.
 */

export type CalendarEmptyReason = 'noLifts' | 'noBookings' | null;

export function calendarEmptyReason(input: {
  isLoading: boolean;
  liftCount: number;
  bookingCount: number;
}): CalendarEmptyReason {
  // Neither message is honest until the data has arrived.
  if (input.isLoading) return null;
  if (input.liftCount === 0) return 'noLifts';
  if (input.bookingCount === 0) return 'noBookings';
  return null;
}
